import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ChecklistComponent from "@Shared/components/checklist/checklist";
import { showToast } from "@Shared/utils/constants";
import Err from "@Broker/js/routes/error";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { mapActions } from "vuex";
import { ADD_REFERRER_CHECKLIST } from "@Broker/@Modules/clients/referrers/store/referrer-actions";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerChecklistTab",
  components: {
    ChecklistComponent,
    SimpleButton
  },
  props: {
    referrerId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      title: "",
      checklist: [],
      loading: false,
      loadingSucceeded: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [ADD_REFERRER_CHECKLIST])), {}, {
    async handleSubmit() {
      this.loading = true;
      try {
        await this.ADD_REFERRER_CHECKLIST({
          id: this.referrerId,
          checklist: this.checklist,
          title: this.title
        });
        this.loadingSucceeded = true;
        this.$emit("submit");
        this.checklist = [];
        this.title = "";
        showToast("success", "checklistCreated");
      } catch (e) {
        this.loadingSucceeded = false;
        Err.handle(e);
      } finally {
        this.loading = false;
      }
    },
    handleUpdate({
      title,
      checklist
    }) {
      this.title = title;
      this.checklist = checklist;
    }
  })
});